var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"access"},[_c('div',{staticClass:"wrap"},[_c('InfoAccess')],1),_c('div',{staticClass:"wrap",staticStyle:{"padding-top":"100px"}},[_c('Introduction')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }